export class StaticConfigServiceAdapter {
  constructor(configData) {
    this.configData = configData;
  }
  getConfiguration() {
    return Promise.resolve({
      ...this.configData
    });
  }
}
export const defaultConfigServiceAdapter = new StaticConfigServiceAdapter({});
//# sourceMappingURL=ConfigServiceAdapter.js.map